var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00008 1.16666C10.2217 1.16666 12.8334 3.77833 12.8334 6.99999C12.8334 10.2217 10.2217 12.8333 7.00008 12.8333C3.77986 12.8298 1.17023 10.2202 1.16675 6.99999C1.16675 3.77833 3.77842 1.16666 7.00008 1.16666ZM5.83342 4.66666C5.53426 4.66666 5.2877 4.89185 5.25401 5.18196L5.25008 5.24999V8.74999C5.25008 9.07216 5.51125 9.33332 5.83342 9.33332C6.13257 9.33332 6.37913 9.10813 6.41282 8.81802L6.41675 8.74999V5.24999C6.41675 4.92782 6.15558 4.66666 5.83342 4.66666ZM8.16675 4.66666C7.86759 4.66666 7.62104 4.89185 7.58734 5.18196L7.58342 5.24999V8.74999C7.58342 9.07216 7.84458 9.33332 8.16675 9.33332C8.4659 9.33332 8.71246 9.10813 8.74616 8.81802L8.75008 8.74999V5.24999C8.75008 4.92782 8.48891 4.66666 8.16675 4.66666Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.893db687.svg";
export { ForwardRef as ReactComponent };